
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M62.406 34.004L32.232 3.873c-1.069-1.069-2.503-1.977-4.304-2.722C26.127.406 24.48.033 22.99.033H5.436c-1.464 0-2.729.535-3.799 1.604C.568 2.706.034 3.972.034 5.435V22.99c0 1.491.373 3.137 1.119 4.938.746 1.801 1.652 3.221 2.722 4.263l30.173 30.215c1.041 1.041 2.307 1.562 3.799 1.562 1.461 0 2.742-.521 3.84-1.562l20.721-20.764c1.039-1.04 1.561-2.306 1.561-3.796-.002-1.463-.524-2.743-1.563-3.842zm-45.05-16.648c-1.055 1.055-2.328 1.583-3.819 1.583s-2.764-.528-3.819-1.583c-1.055-1.055-1.582-2.328-1.582-3.819 0-1.49.527-2.764 1.582-3.818 1.055-1.055 2.328-1.583 3.819-1.583s2.764.528 3.819 1.583c1.056 1.055 1.583 2.328 1.583 3.818 0 1.491-.527 2.765-1.583 3.819z"}})])
          )
        }
      }
    